import { IconButton } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";

export default function PrintButton() {
  return (
    <IconButton onClick={window.print} size="large">
      <PrintIcon />
    </IconButton>
  );
}
